import { useEffect, useState } from 'react';
import { useUIStore } from '../../store/useUIStore';
import { CheckCircle2, AlertCircle, Info, XCircle, X } from 'lucide-react';

export function ToastContainer() {
    const toasts = useUIStore(state => state.toasts);
    const removeToast = useUIStore(state => state.removeToast);

    return (
        <div className="fixed bottom-4 right-4 z-50 flex flex-col gap-2">
            {toasts.map(toast => (
                <Toast key={toast.id} toast={toast} onClose={() => removeToast(toast.id)} />
            ))}
        </div>
    );
}

function Toast({ toast, onClose }: { toast: any, onClose: () => void }) {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        setIsVisible(true);
        return () => setIsVisible(false);
    }, []);

    const icons = {
        success: <CheckCircle2 className="w-5 h-5 text-green-500" />,
        error: <XCircle className="w-5 h-5 text-red-500" />,
        warning: <AlertCircle className="w-5 h-5 text-yellow-500" />,
        info: <Info className="w-5 h-5 text-blue-500" />
    };

    const bgColors = {
        success: 'bg-green-50 border-green-200',
        error: 'bg-red-50 border-red-200',
        warning: 'bg-yellow-50 border-yellow-200',
        info: 'bg-blue-50 border-blue-200'
    };

    const type = toast.type || 'info';

    return (
        <div
            className={`flex items-start gap-3 p-4 rounded-lg border shadow-lg transition-all duration-300 transform 
                ${isVisible ? 'translate-x-0 opacity-100' : 'translate-x-full opacity-0'} 
                ${bgColors[type as keyof typeof bgColors]} max-w-sm w-full`}
        >
            <div className="shrink-0 mt-0.5">
                {icons[type as keyof typeof icons]}
            </div>
            <div className="flex-1">
                {toast.title && <h4 className="text-sm font-bold text-slate-800 mb-1">{toast.title}</h4>}
                <p className="text-sm text-slate-700">{toast.message}</p>
            </div>
            <button
                onClick={onClose}
                title="Cerrar"
                aria-label="Cerrar"
                className="shrink-0 p-1 text-slate-400 hover:text-slate-600 rounded-md transition-colors"
            >
                <X className="w-4 h-4" />
            </button>
        </div>
    );
}
